import { render, staticRenderFns } from "./AddRelatedCourse.vue?vue&type=template&id=13963ccc&scoped=true"
import script from "./AddRelatedCourse.vue?vue&type=script&lang=js"
export * from "./AddRelatedCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13963ccc",
  null
  
)

export default component.exports